
import Appsettings from "@/config/appsettings.json";
import Documents from "@/config/documents.json";
import SocialMedia from "@/config/social-media.json";

export default {
  name: "Footer",
  data() {
    return {
      socialMedia: SocialMedia
    }
  },
  computed: {
    termsAndConditionsPath() {
      return `https://${Appsettings.StaticResourcePath}/${Documents.termsAndConditionsPath}`;
    },
    applicationPolicyPath() {
      return `https://${Appsettings.StaticResourcePath}/${Documents.applicationPolicyPath}`;
    }
  },
};
